// import React, { Component } from "react";
// import { Breadcrumb } from "@gull";
// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory from "react-bootstrap-table2-paginator";
// import queryString from "app/services/queryStringService";
// import _ from "lodash";
// import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";
// // import BankService from "app/services/bankService";
// import EditBank from "./EditBank";
// import { NotificationManager } from "react-notifications";
// import bankService from "app/services/DistributorServices/bankService";

// const { getBankList, bankUpdate } = bankService;
// class BankLists extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       page: 1,
//       data: [],
//       sizePerPage: 10,
//       dataCount: 0,
//       loading: true,
//       editModel: null,
//       editModelValues: {},
//     };
//   }

//   actionFormatter = (cell) => {

//     if (cell == true) {
//       return <span> Active</span>;
//     } else {
//       return <span> Inactive</span>;
//     }
//   };
//   editBankDetails = (row) => {

//     this.setState({ editModelValues: row });
//   };
//   editFormatter = (cell, row) => {
//     return (
//       <>
//         <button
//           type="button"
//           className="btn btn-outline-primary"
//           data-toggle="modal"
//           data-target="#editBankModalforDistributor"
//           onClick={() => this.editBankDetails(row)}
//         >
//           Edit
//         </button>
//       </>
//     );
//   };

//   columns = [
//     {
//       dataField: "bankName",
//       text: "Bank Name",
//       headerStyle: (colum, colIndex) => {
//         return { width: "100px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "shortCode",
//       text: "Bank Short Code",
//       headerStyle: (colum, colIndex) => {
//         return {
//           width: "100px",
//           textAlign: "center",
//         };
//       },

//       //  formatter: this.companyFormatter,
//     },

//     {
//       dataField: "address",
//       text: "Address",
//       headerStyle: (colum, colIndex) => {
//         return { textAlign: "center" };
//       },
//     },
//     {
//       dataField: "accountNumber",
//       text: "Account Number",
//       headerStyle: (colum, colIndex) => {
//         return {
//           width: "150px",
//           textAlign: "center",
//         };
//       },
//     },
//     {
//       dataField: "ifscCode",
//       text: "IFSC Code",
//       headerStyle: (colum, colIndex) => {
//         return {
//           width: "100px",
//           textAlign: "center",
//         };
//       },
//     },
//     {
//       dataField: "branch",
//       text: "Branch",
//       headerStyle: (colum, colIndex) => {
//         return { width: "100px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "swiftCode",
//       text: "Swift Code",
//       headerStyle: (colum, colIndex) => {
//         return { width: "150px", textAlign: "center" };
//       },
//     },
//     {
//       dataField: "status",
//       text: "Status",
//       headerStyle: (colum, colIndex) => {
//         return { width: "100px", textAlign: "center" };
//       },
//       formatter: this.actionFormatter,
//     },
//     {
//       dataField: "id",
//       text: "Edit",
//       headerStyle: (colum, colIndex) => {
//         return { width: "100px", textAlign: "center" };
//       },
//       formatter: this.editFormatter,
//     },
//   ];
//   rowStyle = (row, rowIndex) => {
//     const style = {};
//     style.textAlign = "center";
//     style.fontWeight="600";
//     style.verticalAlign = "center";
//     return style;
//   };

//   NoDataIndication = () => {
//     const { loading } = this.state;
//     //alert(loading);
//     if (loading) {
//       return (
//         <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
//       );
//     } else {
//       return (
//         <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
//           <span className="align-middle"></span>
//           <p> No Data Found</p>
//         </div>
//       );
//     }
//   };

//   loadBankLists = async () => {
//     const { page, sizePerPage } = this.state;
//     const query = queryString.getQueryStringFromObj({
//       pageNumber: page,
//       pageSize: sizePerPage,
//     });
//     if (this.state.dataCount !== 0) {
//       this.setState({ loading: true });
//     }
//     const response = await getBankList(query);

//     const data = response.data;
//     // const paggingData = JSON.parse(response.headers["x-pagination"]);
//     // console.log(paggingData);
//     this.setState({
//       loading: false,
//       data,
//       dataCount: data.length,
//       page: 1,
//       sizePerPage: 10,
//     });
//   };

//   async componentDidMount() {
//     await this.loadBankLists();
//   }

//   handleTableChange = async (type, { page, sizePerPage }) => {
//     const currentIndex = (page - 1) * sizePerPage;
//     this.setState(() => ({
//       page,
//       sizePerPage,
//     }));
//     return false;
//     setTimeout(async () => {
//       await this.loadBankLists();
//     }, 10);
//   };

//   handleSearch = async () => {
//     this.setState(() => ({
//       page: 1,
//       sizePerPage: 10,
//     }));

//     setTimeout(async () => {
//       await this.loadBankLists();
//     }, 10);
//   };

//   handleEditSubmit = async (data) => {
//     // const res = await bankUpdate(data.id, data);
//     // document.getElementsByClassName("close")[0].click();
//     // await this.loadBankLists();
//     try {
//       const res = await bankUpdate(data.id, data);
//     document.getElementsByClassName("close")[0].click();
//     await this.loadBankLists();
//       if (res) {
//         NotificationManager.success("Updated Successfully.");

//       }
//     } catch (error) {
//       NotificationManager.error(error);
//       console.log(error);
//     }

//   };

//   render() {
//     const { data, sizePerPage, page, dataCount, loading } = this.state;

//     const sizePerPageRenderer = ({
//       options,
//       currSizePerPage,
//       onSizePerPageChange,
//     }) => (
//       <>
//         <label className="mr-2">Page Size</label>
//         <div className="btn-group mr-4" role="group">
//           {options.map((option) => {
//             const isSelect = currSizePerPage === `${option.page}`;
//             return (
//               <button
//                 key={option.text}
//                 type="button"
//                 onClick={() => onSizePerPageChange(option.page)}
//                 className={`btn btn-sm ${
//                   isSelect ? "btn-primary" : "btn-secondary"
//                 }`}
//               >
//                 {option.text}
//               </button>
//             );
//           })}
//         </div>
//       </>
//     );

//     const paginationOptions = {
//       paginationSize: 5,
//       pageStartIndex: 1,
//       firstPageText: "First",
//       prePageText: "Back",
//       nextPageText: "Next",
//       lastPageText: "Last",
//       nextPageTitle: "First page",
//       prePageTitle: "Pre page",
//       firstPageTitle: "Next page",
//       lastPageTitle: "Last page",
//       showTotal: true,
//       totalSize: dataCount,
//       sizePerPageList: [
//         {
//           text: "10",
//           value: 10,
//         },
//         {
//           text: "15",
//           value: 15,
//         },
//         {
//           text: "20",
//           value: 20,
//         },
//         {
//           text: "50",
//           value: 50,
//         },
//       ],
//       sizePerPageRenderer,
//     };

//     return (
//       <>
//         <Link
//           className="btn btn-primary btn-md float-right"
//           to="/distributor/bank/add"
//         >
//           <i className="i-Add-User text-white mr-2"></i> Add Bank
//         </Link>
//         <Helmet>
//           <title>Bank List</title>
//         </Helmet>
//         <Breadcrumb routeSegments={[{ name: "Bank List" }]}></Breadcrumb>

//         <div>
//           <BootstrapTable
//             hover
//             //  remote
//             keyField="id"
//             data={data}
//             columns={this.columns}
//             pagination={paginationFactory(paginationOptions)}
//             onTableChange={this.handleTableChange}
//             noDataIndication={() => <this.NoDataIndication />}
//             headerClasses="bg-primary text-white"
//             bodyClasses="react-bootstrap-table-next-min-height"
//             expandRow={this.expandRow}
//             rowStyle={this.rowStyle}
//           />
//         </div>
//         {this.state.editModelValues ? (
//           <EditBank
//             editModelValues={this.state.editModelValues}
//             handleEditSubmit={this.handleEditSubmit}
//           />
//         ) : (
//           ""
//         )}
//       </>
//     );
//   }
// }
// export default BankLists;
import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import queryString from "app/services/queryStringService";
import _ from "lodash";

import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import EditBank from "./EditBank";
import { NotificationManager } from "react-notifications";
import {
  getBankList,
  bankUpdate,
  deleteBanks,
} from "app/services/AdminServices/bankService";
import { MdDelete } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import { Button, Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";

const BankLists = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [editModelValues, setEditModelValues] = useState({});

  const actionFormatter = (cell) => {
    if (cell === true) {
      return <span className="text-success"> Active</span>;
    } else {
      return <span className="text-danger"> Inactive</span>;
    }
  };

  const editBankDetails = (row) => {
    setEditModelValues(row);
  };

  const editFormatter = (cell, row) => {
    return (
      <>
        <Button
          variant="outline-primary"
          data-bs-toggle="modal"
          data-bs-target="#editBankModal"
          onClick={() => editBankDetails(row)}
        >
          Edit
        </Button>
        {/* <AiFillEdit
          data-bs-toggle="modal"
          data-bs-target="#editBankModal"
          onClick={() => editBankDetails(row)}
          size="1.5em"
          color="black"
        ></AiFillEdit> */}
      </>
    );
  };

  const columns = [
    {
      dataField: "bankName",
      text: "Bank Name",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "shortCode",
      text: "Bank Short Code",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },

      //  formatter: this.companyFormatter,
    },

    {
      dataField: "address",
      text: "Address",
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "accountNumber",
      text: "Account Number",
      headerStyle: () => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "ifscCode",
      text: "IFSC Code",
      headerStyle: () => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "swiftCode",
      text: "Swift Code",
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: editFormatter,
    },
    // Rest of the columns...
  ];

  const rowStyle = () => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadBankLists = async () => {
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getBankList();
    const data = response.data;

    setData(data);
    setDataCount(data.length);
    setLoading(false);
  };

  useEffect(() => {
    loadBankLists();
  }, []);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    // return false; // No need for this
    setTimeout(async () => {
      await loadBankLists();
    }, 10);
  };

  const handleEditSubmit = async (data) => {
    try {
      const res = await bankUpdate(data.id, data);
      document.getElementsByClassName("btn-close")[0].click();
      await loadBankLists();
      if (res) {
        NotificationManager.success("Updated Successfully.");
      }
    } catch (error) {
      NotificationManager.error(error);
      console.log(error);
    }
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Link
        className="btn btn-primary btn-md float-end"
        to="/distributor/bank/add"
      >
        <i className="i-Add-User text-white mr-2"></i> Add Bank
      </Link>
      <Helmet>
        <title>Bank List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Bank List" }]}></Breadcrumb>

      <div>
        <BootstrapTable
          hover
          //  remote
          keyField="id"
          data={data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
      {editModelValues ? (
        <EditBank
          editModelValues={editModelValues}
          handleEditSubmit={handleEditSubmit}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default BankLists;
